module.exports = __webpack_public_path__ + "static/media/icon_plus_gray.1b43a4d4.svg";